import {
  Firestore,
  doc,
  getDoc,
  getDocs,
  collection,
  query,
  QueryConstraint,
} from "firebase/firestore";

/**
 * @description Function to get document's data given document's id
 *
 * @param Params object
 * @returns Document or null
 */
async function getDocument({
  collectionName,
  docId,
  db,
}: {
  collectionName: string;
  docId: string;
  db: Firestore;
}) {
  const docRef = doc(db, collectionName, docId);
  const docSnapshot = await getDoc(docRef);

  if (docSnapshot.exists()) {
    return docSnapshot.data();
  }
  return null;
}

async function getDocuments({
  collectionName,
  constraint,
  db,
}: {
  collectionName: string;
  constraint?: QueryConstraint;
  db: Firestore;
}) {
  let q;

  if (constraint) {
    q = query(collection(db, collectionName), constraint);
  } else {
    q = query(collection(db, collectionName));
  }
  const querySnapshot = await getDocs(q);

  if (!querySnapshot.empty) {
    return querySnapshot.docs.map((doc) => doc.data());
  }
  return null;
}

export { getDocument, getDocuments };
